import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import React from 'react';
import {
	INVOICE_CARD_PAST_DUE_TITLE,
	INVOICE_CARD_SETTLED_TITLE,
	INVOICE_CARD_TITLE,
} from './constants';

export const InvoiceDataCard = ({ data }: any) => {
	const totalInvoices = parseInt(data.count_invoices, 10) || 0;
	const settledInvoices = parseInt(data.count_invoices_settled, 10) || 0;
	const pastDueInvoices = parseInt(data.count_invoices_past_due, 10) || 0;

	return (
		<Card sx={{ width: { xs: 'auto', sm: 1 / 3 } }}>
			<CardContent>
				<Grid container justifyContent='space-between' spacing={3}>
					<Grid item style={{ width: '100%' }}>
						<Box
							display='flex'
							alignItems='center'
							justifyContent='space-between'
						>
							<Typography gutterBottom variant='subtitle1'>
								{INVOICE_CARD_TITLE}
							</Typography>
							<Typography gutterBottom variant='subtitle1'>
								{totalInvoices.toLocaleString()}
							</Typography>
						</Box>
						<Box
							mt={2}
							display='flex'
							alignItems='center'
							justifyContent='space-between'
						>
							<Typography variant='subtitle2' color='textSecondary'>
								{INVOICE_CARD_SETTLED_TITLE}
							</Typography>
							<Typography color='textSecondary' variant='subtitle2'>
								{settledInvoices.toLocaleString()}
							</Typography>
						</Box>
						<Box
							mt={2}
							display='flex'
							alignItems='center'
							justifyContent='space-between'
						>
							<Typography variant='subtitle2' color='textSecondary'>
								{INVOICE_CARD_PAST_DUE_TITLE}
							</Typography>
							<Typography color='textSecondary' variant='subtitle2'>
								{pastDueInvoices.toLocaleString()}
							</Typography>
						</Box>
					</Grid>
				</Grid>
			</CardContent>
		</Card>
	);
};
